/**
 * Utility functions for sector name translations
 */

// Mapping from English sector names to translation keys
const sectorNameToKeyMap = {
  "Bank - Corporate/SME": "BANK_CORPORATE_SME",
  "Bank - Retail/Consumer": "BANK_RETAIL_CONSUMER",
  "Bank - State-owned": "BANK_STATEOWNED",
  "Chemicals - Fertilizer (Urea)": "CHEMICALS_FERTILIZER_UREA",
  "Chemicals - Phosphate/DAP": "CHEMICALS_PHOSPHATE_DAP",
  "Construction - Contractors": "CONSTRUCTION_CONTRACTORS",
  "Consumer Discretionary": "CONSUMER_DISCRETIONARY",
  "Logistics & Ports": "LOGISTICS_AND_PORTS",
  "Oil & Gas - Downstream (Refining/Petrochem)": "OIL_AND_GAS_DOWNSTREAM_REFINING_PETROCHEM",
  "Oil & Gas - Services/Midstream": "OIL_AND_GAS_SERVICES_MIDSTREAM",
  "Oil & Gas - Upstream (E&P)": "OIL_AND_GAS_UPSTREAM_EANDP",
  "Real Estate - Industrial Parks (KCN)": "REAL_ESTATE_INDUSTRIAL_PARKS_KCN",
  "Real Estate - Residential": "REAL_ESTATE_RESIDENTIAL",
  "Securities - Brokerage/Margin": "SECURITIES_BROKERAGE_MARGIN",
  "Securities - Investment Banking": "SECURITIES_INVESTMENT_BANKING",
  "Steel - Construction (Rebar)": "STEEL_CONSTRUCTION_REBAR",
  "Steel - Flat/HRC": "STEEL_FLAT_HRC",
  "Utilities / Defensive": "UTILITIES_DEFENSIVE"
};

/**
 * Get the translation key for a sector name
 * @param {string} sectorName - The English sector name from the API
 * @returns {string} - The translation key, or the original name if not found
 */
export const getSectorTranslationKey = (sectorName) => {
  return sectorNameToKeyMap[sectorName] || sectorName;
};

/**
 * Translate a sector name using the i18n system
 * @param {Function} t - The translation function from react-i18next
 * @param {string} sectorName - The English sector name from the API
 * @returns {string} - The translated sector name
 */
export const translateSectorName = (t, sectorName) => {
  const key = getSectorTranslationKey(sectorName);
  // Try to get the translation from the sectors namespace
  const translated = t(`sectors.${key}`, { defaultValue: sectorName });
  return translated;
};